import { render, staticRenderFns } from "./Popupbar.vue?vue&type=template&id=11b60b89&scoped=true&lang=html&"
import script from "./Popupbar.vue?vue&type=script&lang=js&"
export * from "./Popupbar.vue?vue&type=script&lang=js&"
import style0 from "./Popupbar.vue?vue&type=style&index=0&id=11b60b89&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b60b89",
  null
  
)

export default component.exports